import { SerializePayloadHandler_link } from '../components/link/serialize';
import { SerializePayloadHandler_mention } from '../components/mention/serialize';
import { SerializePayloadHandler_emoji } from '../components/emoji/serialize';
import { SerializePayload } from './serialize';

export * from './serialize';

export const serializePayload = new SerializePayload([
  new SerializePayloadHandler_emoji(),
  new SerializePayloadHandler_mention(),
  new SerializePayloadHandler_link(),
]);
